import React, { useEffect, useState, useRef } from "react";
import "./loginform.css";
import { useNavigate } from "react-router-dom";
import { baseUrl } from '../shared';
import axios from "axios";
import { setGlobalState, useGlobalState } from '../state/index';
import { useAuth } from './useAuth';

export default function LoginForm() {

    const classLink_WhiteImg = require("../menu_icons/SIWCL.png");

    const [errorMessage, setErrorMessage] = useState("");
    const [errorDistrictMSG, setErrorDistrictMSG] = useState("");
    const [errorStudentMSG, setErrorStudentMSG] = useState("");
    const [errorDOBMSG, setErrorDOBMSG] = useState("");

    const [districtId, setDistrictId] = useState();
    const [studentID, setStudentID] = useState();
    const [showStudentID, setShowStudentID] = useState(false);

    const [displayValue, setDisplayValue] = useState("");
    const maskTimeout = useRef(null);


    const [studentDisplay, setStudentDisplay] = useState("�");
    const studentMaskTimeout = useRef(null);

    const [passcodeDisplay, setPasscodeDisplay] = useState("");
    const passcodeMaskTimeout = useRef(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isPasscodeLoading, setIsPasscodeLoading] = useState(false);
    const mask = (n) => "●".repeat(Math.max(0, n));

    const [showWarningPopup, setShowWarningPopup] = useState(false);
    const [warningMessage, setWarningMessage] = useState("");

    const navigate = useNavigate();
    const { login } = useAuth();

    const [showPasscode, setShowPasscode] = useState(false);


    // PASSCODE SYSTEM
    const [passCodeCheck, setPassCodeCheck] = useState(0);
    const passcodeRef = useRef(null);
    const [passcodeError, setPasscodeError] = useState("");

    const currentYear = new Date().getFullYear();
    const [day, setDay] = useState('');
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');

    const years = Array.from({ length: 100 }, (_, index) => currentYear - index);

    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !isLoading) {
            e.preventDefault();
            popup();
        }
    };

    const isLeapYear = (year) => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

    const getDaysInMonth = (month, year) => {
        const daysInMonth = {
            1: 31, 2: isLeapYear(year) ? 29 : 28, 3: 31, 4: 30,
            5: 31, 6: 30, 7: 31, 8: 31, 9: 30, 10: 31,
            11: 30, 12: 31
        };
        return daysInMonth[month] || 31;
    };

    const days = month === "" ? [] : Array.from(
        { length: getDaysInMonth(month, year) },
        (_, index) => index + 1
    );

    useEffect(() => {
        // Check for seaccessreadonly URL parameter
        const params = new URLSearchParams(window.location.search);
        const urlSEAccessReadOnly = params.get("seaccessreadonly");
        if (urlSEAccessReadOnly) {
            const isReadOnly = urlSEAccessReadOnly.toLowerCase() === "true";
            setGlobalState("SEAccessReadOnly", isReadOnly);
            sessionStorage.setItem("SEAccessReadOnly", isReadOnly.toString());
        }

        const savedDistrictId = localStorage.getItem("districtId");
        const savedStudentID = localStorage.getItem("studentID");
        const savedDOB = localStorage.getItem("dob");

        if (savedDistrictId && savedStudentID && savedDOB) {
            setDistrictId(savedDistrictId);
            setStudentID(savedStudentID);
            setStudentDisplay("●".repeat(savedStudentID.length));

            const [savedYear, savedMonth, savedDay] = savedDOB.split("-");
            setYear(savedYear);
            setMonth(savedMonth);
            setDay(savedDay);
        }
    }, []);

    // MAIN LOGIN (FIRST ATTEMPT)
    const popup = () => {
        // start loading
        setIsLoading(true);

        const url = baseUrl + 'api/Login/StudentLoginWithPassCode';

        const data = {
            districtID: districtId?.trim(),
            studentID: studentID?.trim(),
            dob: `${year}-${month}-${day}`,
            AuthenticationCode: "",
        };

        setErrorDistrictMSG("");
        setErrorStudentMSG("");
        setErrorDOBMSG("");
        setErrorMessage("");
        setPasscodeError("");

        if (!districtId || !studentID || !year || !month || !day) {
            if (!districtId) setErrorDistrictMSG("District ID is required");
            if (!studentID) setErrorStudentMSG("Student ID is required");
            if (!year || !month || !day) setErrorDOBMSG("Date of birth is required");

            setIsLoading(false);  // ❗ STOP loading when validation fails
            return;
        }

        axios.post(url, data)
            .then((result) => {

                const passCodeCheckValue = Number(result.data?.data?.passCodeCheck || 0);
                setPassCodeCheck(passCodeCheckValue);

                const warning = result.data?.data?.warningMessage;

                if (passCodeCheckValue === 1) {

                    // Reset passcode fields
                    passcodeRef.current = "";
                    setPasscodeDisplay("");
                    if (passcodeMaskTimeout.current)
                        clearTimeout(passcodeMaskTimeout.current);

                    setWarningMessage(warning || "");
                    setShowWarningPopup(true);

                    setIsLoading(false);  // ❗ STOP loading
                    return;
                }

                finishLogin(result);   // Go to home
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage("Unable to login. Try again.");
                setIsLoading(false);   // ❗ STOP login sppiner loading on error
            });
    };


    // COMPLETE LOGIN (USED BY NORMAL + PASSCODE LOGIN)

    const finishLogin = (result) => {

        const loginResult = result.data;

        if (loginResult && loginResult !== "Student Code does not exist") {

            let DOB = "DOB";
            loginResult[DOB] = `${month}-${day}-${year}`;

            setGlobalState("authtoken", result.data.authtoken);
            login(result.data.authtoken);

            const d = result.data.data;

            setGlobalState("StudentKey", d.studentKey);
            setGlobalState("FirstName", d.firstName);
            setGlobalState("LastName", d.lastName);
            setGlobalState("FullName", d.fullName);
            setGlobalState("DistrictID", d.districtID);
            setGlobalState("HideTeksTracker", d.hideTeksTracker);

            sessionStorage.setItem("FullName", d.fullName);
            sessionStorage.setItem("studentkey", d.studentKey);
            sessionStorage.setItem("districtID", districtId);
            sessionStorage.setItem("DistrictName", d.districtName);
            sessionStorage.setItem("authToken", result.data.authtoken);
            sessionStorage.setItem("HideTeksTracker", d.hideTeksTracker);

            if (d.studentExplorer_LoginAutoComplete) {
                localStorage.setItem("districtId", districtId);
                localStorage.setItem("studentID", studentID);
                localStorage.setItem("dob", `${year}-${month}-${day}`);
            }

            sessionStorage.setItem("HomeFormData", JSON.stringify({
                ...loginResult,
                DOB: `${year}-${month}-${day}`
            }));

            navigate("/HomeForm");
        }

        else {
            setIsLoading(false);  //Stop Login Spinner
            setErrorMessage(
                "Student combination not found. Please check District ID, Student ID, Date of Birth or Student Code."
            );
        }
    };

    // PASSCODE SUBMIT
    const handleWarningOk = () => {
        const enteredPasscode = (passcodeRef.current || "").trim();

        setPasscodeError("");

        if (passCodeCheck === 1 && !enteredPasscode) {
            setPasscodeError("Passcode is required");
            return;
        }

        setIsPasscodeLoading(true);   // START SPINNER

        const url = baseUrl + 'api/Login/StudentLoginWithPassCode';

        const data = {
            districtID: districtId?.trim(),
            studentID: studentID?.trim(),
            dob: `${year}-${month}-${day}`,
            AuthenticationCode: enteredPasscode
        };

        axios.post(url, data)
            .then((result) => {
                const d = result.data.data;

                const passcodeAccepted = d.passCode === "True";

                if (!passcodeAccepted) {
                    setPasscodeError(d.passCodeError || "Invalid passcode.");
                    setIsPasscodeLoading(false);   // STOP SPINNER ❗
                    return;
                }

                finishLogin(result);   // navigates to home → no need to stop spinner
            })
            .catch((err) => {
                console.error(err);
                setPasscodeError("Error verifying passcode.");
                setIsPasscodeLoading(false);   // STOP SPINNER ❗
            });
    };



    return (
        <div translate="no" className="page" style={{ display: 'flex', flexDirection: 'column' }}>
            <div className="cover">
                <h1>Student Portal</h1>

                <input className="inputlogin" placeholder="District ID"
                    value={districtId || ""} onChange={(e) => setDistrictId(e.target.value)} onKeyDown={handleKeyDown} />

                {errorDistrictMSG && <span style={{ color: "red", marginBottom: "15px", marginTop: "-40px" }}>{errorDistrictMSG}</span>}

                <div className="input-wrapper" style={{ position: "relative" }}>

                    <input
                        type="text"
                        className="inputlogin"
                        placeholder="Student ID"
                        value={studentDisplay}
                        onKeyDown={handleKeyDown}
                        onChange={(e) => {
                            const rawInput = e.target.value;
                            const oldReal = studentID || "";

                            if (showStudentID) {
                                setStudentID(rawInput);
                                setStudentDisplay(rawInput);
                                return;
                            }

                            const hasMaskChar = rawInput.includes("●");

                            if (!hasMaskChar && rawInput.length > 0 && rawInput.length !== oldReal.length) {
                                setStudentID(rawInput);
                                setStudentDisplay(mask(rawInput.length - 1) + rawInput.slice(-1));
                                if (studentMaskTimeout.current) clearTimeout(studentMaskTimeout.current);
                                studentMaskTimeout.current = setTimeout(() => {
                                    setStudentDisplay(mask(rawInput.length));
                                }, 400);
                                return;
                            }

                            if (rawInput.length > oldReal.length + 1 && hasMaskChar) {
                                const realPart = rawInput.replace(/●/g, "");
                                if (realPart.length > 0) {
                                    const combined = oldReal + realPart;
                                    setStudentID(combined);
                                    setStudentDisplay(mask(combined.length - 1) + combined.slice(-1));
                                    if (studentMaskTimeout.current) clearTimeout(studentMaskTimeout.current);
                                    studentMaskTimeout.current = setTimeout(() => {
                                        setStudentDisplay(mask(combined.length));
                                    }, 400);
                                    return;
                                }
                                // else fall through
                            }

                            // Backspace
                            if (rawInput.length < oldReal.length) {
                                const newReal = oldReal.slice(0, -1);
                                setStudentID(newReal);
                                setStudentDisplay(mask(newReal.length));
                                return;
                            }

                            // Normal typing
                            let lastChar = rawInput.slice(-1);
                            if (hasMaskChar) {
                                lastChar = rawInput.slice(-1);
                            } else {
                                lastChar = rawInput.slice(-1);
                            }

                            const newReal = oldReal + lastChar;
                            setStudentID(newReal);
                            setStudentDisplay(mask(newReal.length - 1) + lastChar);

                            if (studentMaskTimeout.current) clearTimeout(studentMaskTimeout.current);
                            studentMaskTimeout.current = setTimeout(() => {
                                setStudentDisplay(mask(newReal.length));
                            }, 400);
                        }}

                    />

                    {/* EYE ICON */}
                    <span
                        className="eye-btn"
                        style={{
                            position: "absolute",
                            right: "12px",
                            top: "29%",
                            transform: "translateY(-50%)",
                            cursor: "pointer"
                        }}
                        onMouseDown={() => {
                            if (studentMaskTimeout.current)
                                clearTimeout(studentMaskTimeout.current);

                            setShowStudentID(true);
                            setStudentDisplay(studentID);
                        }}
                        onMouseUp={() => {
                            setShowStudentID(false);
                            setStudentDisplay(mask(studentID.length));
                        }}
                        onMouseLeave={() => {
                            setShowStudentID(false);
                            setStudentDisplay(mask(studentID.length));
                        }}
                    >
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="black"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
                            <circle cx="12" cy="12" r="3" />
                        </svg>
                    </span>
                </div>


                {errorStudentMSG && <span style={{ color: "red", marginBottom: "15px", marginTop: "-40px" }}>{errorStudentMSG}</span>}

                {/* DOB */}
                <div className="dateOfBirth">
                    <select value={month} onChange={(e) => setMonth(e.target.value)}>
                        <option value="">Month</option>
                        {months.map((m, i) => (
                            <option key={i + 1} value={i + 1}>{m}</option>
                        ))}
                    </select>

                    <select value={day} onChange={(e) => setDay(e.target.value)}>
                        <option value="">Day</option>
                        {days.map((d) => (
                            <option key={d} value={d}>{d}</option>
                        ))}
                    </select>

                    <select value={year} onChange={(e) => setYear(e.target.value)}>
                        <option value="">Year</option>
                        {years.map((y) => (
                            <option key={y} value={y}>{y}</option>
                        ))}
                    </select>
                </div>

                {errorDOBMSG && <span style={{ color: "red", marginBottom: "15px", marginTop: "-28px" }}>{errorDOBMSG}</span>}

                {errorMessage && <span style={{ color: "red", marginBottom: "5px", textAlign: "center", padding: "0 4px", fontSize: "16px" }}>{errorMessage}</span>}

                <div
                    className="login-btn"
                    onClick={!isLoading ? popup : null}
                    style={{
                        opacity: isLoading ? 0.6 : 1,
                        pointerEvents: isLoading ? "none" : "auto"
                    }}
                >
                    {isLoading ? (
                        <div className="spinner"></div>
                    ) : (
                        "Login"
                    )}
                </div>
            </div>

            {/* CLASSLINK */}
            <div style={{ marginTop: '10px' }}>
                <a
                    href="https://launchpad.classlink.com/oauth2/v2/auth?scope=profile&redirect_uri=https%3A%2F%2Fexplorer.tangosoftware.com%2Fclasslink&client_id=c1744210236732dff7b1d86ef51fc8d6d4b7de8bb6e2&response_type=code"
                    target="_blank" rel="noopener noreferrer"
                >
                    <img src={classLink_WhiteImg} alt="ClassLink"
                        style={{ width: "250px", height: "45px" }} />
                </a>
            </div>

            {/* WARNING POPUP WITH PASSCODE */}
            {showWarningPopup && (
                <div className="warning-popup-overlay">
                    <div className="warning-popup">
                        <h3>Warning</h3>
                        <p>{warningMessage}</p>

                        {passCodeCheck === 1 && (
                            <div style={{ marginTop: "15px" }}>
                                <p>Please enter Passcode to proceed.</p>

                                <div className="input-wrapper" style={{ position: "relative", width: "100%" }}>
                                    <input
                                        type="text"
                                        className="inputlogin"
                                        placeholder="Enter Passcode"
                                        style={{
                                            marginBottom: "20px",
                                            border: "1px solid #2D4D93",
                                            paddingRight: "40px"
                                        }}
                                        value={passcodeDisplay}
                                        onChange={(e) => {
                                            const rawInput = e.target.value;
                                            const oldReal = passcodeRef.current || "";

                                            if (showPasscode) {
                                                passcodeRef.current = rawInput;
                                                setPasscodeDisplay(rawInput);
                                                return;
                                            }

                                            const hasMaskChar = rawInput.includes("●");

                                            if (!hasMaskChar && rawInput.length > 0 && rawInput.length !== oldReal.length) {
                                                passcodeRef.current = rawInput;

                                                // briefly show last char then mask
                                                setPasscodeDisplay(mask(rawInput.length - 1) + rawInput.slice(-1));

                                                if (passcodeMaskTimeout.current) clearTimeout(passcodeMaskTimeout.current);
                                                passcodeMaskTimeout.current = setTimeout(() => {
                                                    setPasscodeDisplay(mask(rawInput.length));
                                                }, 400);

                                                return;
                                            }
                                            
                                            if (rawInput.length > oldReal.length + 1 && hasMaskChar) {
                                                const realPart = rawInput.replace(/●/g, "");
                                                if (realPart.length > 0) {
                                                    passcodeRef.current = oldReal + realPart;
                                                    setPasscodeDisplay(mask(passcodeRef.current.length - 1) + passcodeRef.current.slice(-1));
                                                    if (passcodeMaskTimeout.current) clearTimeout(passcodeMaskTimeout.current);
                                                    passcodeMaskTimeout.current = setTimeout(() => {
                                                        setPasscodeDisplay(mask(passcodeRef.current.length));
                                                    }, 400);
                                                    return;
                                                }
                                            }

                                            // BACKSPACE / delete
                                            if (rawInput.length < oldReal.length) {
                                                const newReal = oldReal.slice(0, -1);
                                                passcodeRef.current = newReal;
                                                setPasscodeDisplay(mask(newReal.length));
                                                return;
                                            }

                                           
                                            let lastChar = rawInput.slice(-1);
                                            if (hasMaskChar) {
                                                lastChar = rawInput.slice(-1);
                                            } else {
                                                lastChar = rawInput.slice(-1);
                                            }

                                            const newReal = oldReal + lastChar;
                                            passcodeRef.current = newReal;

                                            setPasscodeDisplay(mask(newReal.length - 1) + lastChar);

                                            if (passcodeMaskTimeout.current) clearTimeout(passcodeMaskTimeout.current);
                                            passcodeMaskTimeout.current = setTimeout(() => {
                                                setPasscodeDisplay(mask(newReal.length));
                                            }, 400);
                                        }}

                                    />

                                    {/* EYE BUTTON */}
                                    <span
                                        className="eye-btn"
                                        style={{
                                            position: "absolute",
                                            right: "12px",
                                            top: "36%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer"
                                        }}
                                        onMouseDown={() => {
                                            if (passcodeMaskTimeout.current)
                                                clearTimeout(passcodeMaskTimeout.current);

                                            setShowPasscode(true);
                                            setPasscodeDisplay(passcodeRef.current || "");
                                        }}
                                        onMouseUp={() => {
                                            setShowPasscode(false);
                                            setPasscodeDisplay(mask((passcodeRef.current || "").length));
                                        }}
                                        onMouseLeave={() => {
                                            setShowPasscode(false);
                                            setPasscodeDisplay(mask((passcodeRef.current || "").length));
                                        }}
                                    >
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="black"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                    </span>
                                </div>


                                {passcodeError && (
                                    <span style={{ color: "red", fontSize: "14px", display: "inline-block" }}>
                                        {passcodeError}
                                    </span>
                                )}
                            </div>

                        )}

                        <div className="warning-popup-buttons">


                            <button
                                className="ok-btn"
                                onClick={!isPasscodeLoading ? handleWarningOk : null}
                                style={{
                                    opacity: isPasscodeLoading ? 0.7 : 1,
                                    pointerEvents: isPasscodeLoading ? "none" : "auto"
                                }}
                            >
                                {isPasscodeLoading ? (
                                    <div className="spinner"></div>
                                ) : (
                                    "OK"
                                )}
                            </button>


                            <button className="cancel-btn"
                                onClick={() => {
                                    setShowWarningPopup(false);
                                    passcodeRef.current = "";
                                    setPasscodeDisplay("");
                                    if (passcodeMaskTimeout.current)
                                        clearTimeout(passcodeMaskTimeout.current);
                                }}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
